

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { Timestamp } from 'firebase/firestore'; 
import { Prontofibra_Firestore } from "src/app/models/prontofibra.firestore.model";
import { ProntofibraService } from "src/app/services/prontofibra.service";
import { ListeService } from "src/app/services/liste.service";
import { ProntofibraDTO } from "src/app/models/prontofibra.dto.model";
import { CategoriaKOProntofibraDTO } from "src/app/models/prontofibra.categoriaAttesa.model";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";
import { CategoriaVincolo } from "src/app/models/categoriaVincolo.model";
  

@Component({
    selector: "component_modifica_categoria_pf",
    templateUrl: "./dialog-modifica_categoria.component.html",
    styleUrls: ["../prontofibra.component.css"],
  })
  export class DialogModificaCategoriaKOProntofibra implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected prontofibra: Prontofibra_Firestore;
    protected modificaCategoriaAttesaForm: FormGroup;
    protected isModificandoCategoriaAttesa:boolean = false;
    protected categorieAppuntamentoKO:CategoriaVincolo[]=[];

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private pfService:ProntofibraService,
      private messageService: MessageService,
      public listeService:ListeService,
      protected stiliService:StiliService,
      private utilService:UtilService
    ) {
      this.prontofibra          = this.config.data.prontofibra;
     this.loadCategorieKO();
     
      
    }
    ngOnInit() {
      this.logger.info("INIT "+ this.categorieAppuntamentoKO.length)
     

      this.modificaCategoriaAttesaForm = this.formBuilder.group({
        //tipo:         [ categoriaVincolo, [Validators.required]],
        categoria:    [ null, [Validators.required]],
        note:         [ this.prontofibra.noteKO]
      });
    }
    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }

    loadCategorieKO(){
      this.utilService.getCategorieAppuntamentoKO().subscribe((categorieVincolo) => {
        this.categorieAppuntamentoKO = categorieVincolo;
        this.logger.info("LOAD CATEGORIE KO "+ this.categorieAppuntamentoKO.length)
        this.listeService.setOpzioniCausaKO(this.categorieAppuntamentoKO.map(categoria => ({
          label: categoria.label,
          value: categoria.codice
        })));
        const categoriaVincolo = this.categorieAppuntamentoKO.find(
          (item) => item.codice === this.prontofibra.categoriaKO
        );
        this.logger.info("LOAD CATEGORIE KO "+ this.prontofibra.categoriaKO + " "+ categoriaVincolo);
        if(categoriaVincolo){
          this.modificaCategoriaAttesaForm.patchValue({
            categoria: categoriaVincolo
          });
        }
       
      });
    }
  
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isModificandoCategoriaAttesa = true;
        let pfDaAggiornare:ProntofibraDTO = new ProntofibraDTO();
        if(this.modificaCategoriaAttesaForm.get('note').value){
          pfDaAggiornare.noteKO = this.modificaCategoriaAttesaForm.get('note').value;
        }
        let categoriaAttesa:CategoriaKOProntofibraDTO = new CategoriaKOProntofibraDTO();
        categoriaAttesa.id = this.modificaCategoriaAttesaForm.get('categoria').value;
        pfDaAggiornare.categoriaKO = categoriaAttesa;
         this.pfService.modificaCategoriaKO(this.prontofibra.id, pfDaAggiornare).subscribe( {
            next: (res) => {
              this.isModificandoCategoriaAttesa = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isModificandoCategoriaAttesa = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di modifica della categoria di attesa del PF!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          }
        );
        } 
      } 
    
  }